module.exports = { 
    $paused: false,
    $pausedByClick : false,
    $audioFile : new Audio('/static/audio.mp3')
};


// WEBPACK FOOTER //
// ./src/variables.js